import { call, put, select } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import fitBounds from 'helpers/map/fitBounds'
import extractBoundsFromCameras from 'helpers/cameras/extractBounds'
import extendBoundsForLabels from 'helpers/markups/extendBoundsForLabels'
import { zoomToAllDevicesSelector } from 'selectors'
import { ZOOM_TO_ALL_DEVICES } from 'actions/mapTypes'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import { updateUiAction } from 'actions/uiActions'

export function* zoomToAllDevices(action) {
  try {
    const { cameras, map: { ref, markups }, networkClosets, wiredDevices, doorControllers, doors } = yield select(zoomToAllDevicesSelector)

    if (!cameras.length && !markups.filter(m => m.type === 'label').length && !networkClosets.length && !wiredDevices.length && !doorControllers.length && !doors.length) {
      return yield put(updateUiAction({ sidebarView: 'cameraList' }))
    }

    let bounds = yield call(extractBoundsFromCameras, { cameras: cameras.filter(c => !c.isMultiImager) })
    bounds = yield call(extendBoundsForLabels, { bounds, markups })
    networkClosets.concat(wiredDevices, doorControllers, doors).forEach(device => bounds.extend(device.location))

    yield call(fitBounds, { ref, bounds })
    yield put(updateUiAction({ sidebarView: 'cameraList' }))
    return bounds
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function* watchZoomToAllDevices() {
  yield* takeEvery(ZOOM_TO_ALL_DEVICES, zoomToAllDevices)
}



// WEBPACK FOOTER //
// ./src/sagas/zoomToAllDevicesSaga.js